import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'ui/i18n';
import { inject, observer } from 'mobx-react';
import { action, computed } from 'mobx';
import { Dropdown } from 'ui/components';
import { findInArray } from 'utils/helpers';

import './InvoiceHoldWeeks.scss';

@inject('AppState', 'CartState', 'CartItemsState')
@observer
export default class InvoiceHoldWeeks extends Component {
	static propTypes = {
		AppState: PropTypes.object.isRequired,
		CartState: PropTypes.object.isRequired,
		CartItemsState: PropTypes.object.isRequired,
		item: PropTypes.object.isRequired,
	};

	@action
	onSelect(value) {
		if (
			this.props.item.order_type.hold_inv_weeks.toString() === value ||
			this.props.item.current_order_type.hold_inv_weeks.toString() === value
		) {
			const selectedOrderType = this.getOrderTypeValue(value);

			this.props.item.order_type = selectedOrderType;

			this.props.CartItemsState.deleteUpdate(
				this.props.item,
				'order_type',
				this.props.CartState.cartItems
			);
		} else {
			const selectedOrderType = this.getOrderTypeValue(value);

			this.props.item.order_type = selectedOrderType;

			this.props.CartItemsState.addUpdate(
				this.props.item,
				this.props.item.order_type,
				'order_type'
			);
		}
	}

	getOrderTypeValue(value) {
		return this.props.CartState.cart.order_types.find(
			type =>
				type.hold_inv_weeks.toString() === value.toString() &&
				type.order_type_group === this.props.item.order_type.order_type_group
		);
	}

	hasSameHoldInvoice() {
		if (this.props.item.is_pack) {
			for (let i = 0; i < this.props.item.offerings.length - 1; i++) {
				if (
					this.props.item.offerings[i].order_type.hold_inv_weeks !==
					this.props.item.offerings[i + 1].order_type.hold_inv_weeks
				) {
					return false;
				}
			}

			return true;
		}
		return false;
	}

	getData(value) {
		const counter = value - 1;
		return Array.from(new Array(value), (val, index) => ({
			value: counter - index,
			text: counter - index,
		}));
	}

	isCompanyStore() {
		return this.props.AppState.isCompanyStore;
	}

	@computed
	get holdInvoiceWeek() {
		const SO3 = 0;
		const YO0 = 5;
		let index = 0;

		if (
			parseInt(this.props.item.order_type.order_type_id, 10) === SO3 ||
			parseInt(this.props.item.order_type.order_type_id, 10) === YO0
		) {
			index = 0;
		} else {
			index = parseInt(this.props.item.order_type.hold_inv_weeks, 10);
		}

		if (this.isCompanyStore()) {
			return 0;
		} else if (
			(index === 0 && this.props.item.pack_id === 0) ||
			(index === 0 &&
				this.props.item.pack_id !== 0 &&
				this.hasSameHoldInvoice())
		) {
			return 0;
		} else if (this.props.item.pack_id !== 0 && this.hasSameHoldInvoice()) {
			return this.props.item.order_type.hold_inv_weeks;
		} else if (this.props.item.pack_id !== 0 && !this.hasSameHoldInvoice()) {
			const holdInvoiceWeekList = [];

			this.props.item.offerings.forEach(item => {
				if (!item.is_configurable) {
					holdInvoiceWeekList.push(item.order_type.hold_inv_weeks);
				}
			});

			if (this.props.item.configurations) {
				this.props.item.configurations.forEach(config => {
					const itemFromOfferings = findInArray(
						this.props.item.offerings,
						config.id,
						'id'
					);
					if (itemFromOfferings) {
						holdInvoiceWeekList.push(
							itemFromOfferings.order_type.hold_inv_weeks
						);
					}
				});
			}

			return (
				<div className="InvoiceHoldSeeComponents">
					{/* leave as is to offset data when we have choose color in the name col */}
					<span
						className={`noWrap ${this.props.item.is_configurable
							? ''
							: 'no-space'}`}
					>
						<FormattedMessage id="item.See_Components" className="noWrap" />
					</span>
					<div className="InvoiceHoldSeeComponentsValues">
						{/* we can't controll table rows so we made this "sh*t to align item name with invoice weeks" */}
						<div className="invisible">
							{this.props.item.name}
						</div>
						{holdInvoiceWeekList.map((item, index) =>
							<div key={index} className="InvoiceHoldWeeks-subsection">
								{item}
							</div>
						)}
					</div>
				</div>
			);
		}

		return index;
	}

	render() {
		const { item } = this.props;
		const invoice = this.holdInvoiceWeek;
		return (
			<div className="InvoiceHoldWeeks">
				{item.initial_order_type.hold_inv_weeks !== 0 &&
				invoice === item.order_type.hold_inv_weeks &&
				!item.order_type.is_read_only
					? <Dropdown
							title={item.order_type.hold_inv_weeks}
							items={this.getData(
								parseInt(item.initial_order_type.hold_inv_weeks, 10) + 1
							)}
							onSelect={this.onSelect.bind(this)}
						/>
					: invoice}
			</div>
		);
	}
}



// WEBPACK FOOTER //
// ./src/ui/components/InvoiceHoldWeeks/index.js